import { Component, OnInit } from '@angular/core';
import { UsuariosService } from '../../../services/usuarios.service';
import { FuncionalidadesService } from '../../../services/funcionalidades.service';
import { UsuarioRolesService } from '../../../services/usuario-roles.service';
import { FuncionalidadRolesService } from '../../../services/funcionalidad-roles.service';
import Swal, { SweetAlertResult } from 'sweetalert2';
import * as $ from 'jquery';

@Component({
  selector: 'app-cons-rol-func-usu',
  templateUrl: './cons-rol-func-usu.component.html',
  styleUrls: ['./cons-rol-func-usu.component.css']
})
export class ConsRolFuncUsuComponent implements OnInit {
  titulo="Consulta de usuarios que cuentan con un rol específico"
  constructor(private usuariosService: UsuariosService,
    private funcionalidadesService: FuncionalidadesService,
    private usuarioRolesService: UsuarioRolesService,
    private funcionalidadRolesService: FuncionalidadRolesService

    )  { }
  idAplicativo:string=''
  idRol:string=''
  funcionalidades:any
  respuesta:any
  listaAplicaciones:any=[]
  listaRoles:any
  pagina:number=1
  usuarios:any=[]
  texto:string=''
  listaUsuario:string[]=[]
  listUsuarioAplicativoRol:any

    ngOnInit(): void {
      $("#cancel").on("click", function() {
        $("#caja").val('');
      });
      this.cargarAplicaciones()
  }

  cargarAplicaciones():void{
    this.funcionalidadRolesService.traerFuncionalidadRoles()
    .subscribe(resp => {
      this.respuesta = resp;
      this.listaAplicaciones = this.respuesta.data;
    });
  }
  cargarRoles(): void{
    this.listaRoles = []
    this.funcionalidadRolesService.traerFuncionalidadRolesById(this.idAplicativo)
    .subscribe(resp => {
      this.respuesta = resp
        this.listaRoles = this.respuesta.data[0].listaRoles;
    });
  }
  cargarUsuarios():void{
    this.usuariosService.traerUsuarioByIdRolIdAplicacion(this.idAplicativo, this.idRol)
    .subscribe(resp => {
      this.respuesta = resp
        this.usuarios = this.respuesta.data;
    });

  }
  buscar(texto:string){
    if(this.idAplicativo==undefined || this.idRol==undefined)
    {
      this.ventanaEmergenteError("Debe seleccionar la aplicación y el rol");
    }else{
      this.usuariosService.traerUsuarioByIdRolIdAplicacionUsuario(this.idAplicativo, this.idRol, texto)
      .subscribe(resp => {
        this.respuesta = resp
          this.usuarios = this.respuesta.data;
      });
    }
  }
  borrar(){
    this.cargarUsuarios()
  }
  todos(e: any): void{
    this.listaUsuario = [];
    this.usuarios.forEach((x: { inicio: any; idUsuario: string; }) => {
      x.inicio = e.target.checked
      if (e.target.checked) {
        this.listaUsuario.push(x.idUsuario)
      }
    });
  }
  agregarUsuario(e: any): void{
    if (e.target.checked) {
      this.listaUsuario.push(e.target.value);
    } else {
      this.listaUsuario = this.listaUsuario.filter(data=>data!=e.target.value)
    }
  }

  ventanaEmergenteError(mensaje: string): void{
    Swal.fire({
      title: 'Operación no exitosa',
      text: `${ mensaje }`,
      iconHtml: '<img src="assets/img/error.png" class="w-75 ms-2">',
      customClass: {
        icon: 'no-bordes',
        title: 'text-danger'
      },
      allowOutsideClick: false,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#0d6efd'
    });
  }
  quitar(){
    let usuario:any
    const idRol = 'c4d854a5-3654-4b1a-86cc-48535df9b4e1'
    this.listUsuarioAplicativoRol=[]
    if(this.listaUsuario.length==0){
      this.ventanaEmergenteError("Debe seleccionar al menos un usuario");
    }else  if(this.idAplicativo==undefined || this.idRol==undefined)
      {
        this.ventanaEmergenteError("Debe seleccionar la aplicación y el rol");
      }else{
        this.ventanaEmergenteWarning("Se van a retirar los roles de los usuarios seleccionados en las aplicaciones")
        .then(resp => {
          if (resp.value) {
            this.listaUsuario.forEach(data => {
              usuario ={
                idAplicativo:'',
                idRole:'',
                idUsuario:''
              }
              usuario.idAplicativo = this.idAplicativo
              usuario.idRole = idRol
              usuario.idUsuario = data
              this.listUsuarioAplicativoRol.push(usuario)
            });
          }
          this.usuariosService.guardarAplicativoRolUsuario(this.listUsuarioAplicativoRol)
          .subscribe(resp => {
          if (resp.data!=null) {
              this.ventanaEmergenteExito();
              this.cancelar();
            } else {
              this.ventanaEmergenteError('No fue posible quitar los roles a los usuarios');
            }
          });
        });
      }

  }

  cancelar(){
    this.listaUsuario=[]
    this.idAplicativo=''
    this.idRol=''
    this.usuarios=[]
  }

  ventanaEmergenteExito(): void{
    Swal.fire({
      title: 'Operación exitosa',
      iconHtml: '<img src="assets/img/success.png" class="w-75 ms-2">',
      customClass: {
        icon: 'no-bordes',
        title: 'text-success'
      },
      allowOutsideClick: false,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#0d6efd'
    });
  }
  ventanaEmergenteWarning(mensaje: string): Promise<SweetAlertResult>{

    return Swal.fire({
      html: `${ mensaje }` +
            '<h4 class="text-warning fw-bold mt-3">¿Desea continuar?</h4>',
      iconHtml: '<img src="assets/img/warning.png" class="w-75 ms-2">',
      customClass: {
        icon: 'no-bordes'
      },
      allowOutsideClick: false,
      showCloseButton: true,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Continuar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#0d6efd'
    });

  }

}
